import { Rectangle } from '../../interfaces';
import { PageElement } from './page-element';
import { getAnnotationRectangle } from '../../common';
import { Core } from '@pdftron/webviewer';


export class TextNoteElement extends PageElement {
    private text: string;

    get textContent() {
        return this.text;
    }

    set textContent(value: string) {
        this.text = value;
    }

    get boundary(): Rectangle | null {
        return getAnnotationRectangle((this.element as Core.Annotations.Annotation), this.pageXOffset, this.pageHeight);
    }

    constructor(element: Core.Annotations.Annotation, textContent: string, private pageXOffset, private pageHeight) {
        super(element);

        this.textContent = textContent;
    }
}
